import React from 'react'
import Head from 'next/head'

import { isToggleEnabled } from 'configs/toggle-feature'
import AccountApp from 'app/Homepage/pages/Account'
import { getDeviceId } from 'utils/deviceId'

export async function getServerSideProps(ctx) {
  const isRuangGtkEnabled = await isToggleEnabled('ruang-gtk-enabled')
  const isRuangGtkV3Enabled = await isToggleEnabled('ruang-gtk-enabled-v3')

  return {
    props: {
      appDeviceID: getDeviceId(ctx),
      isRuangGtkEnabled,
      isRuangGtkV3Enabled,
    },
  }
}

export const AccountPage = ({
  isRuangGtkEnabled = false,
  isRuangGtkV3Enabled = false,
}) => {
  return (
    <>
      <Head>
        <title>Akun - Ruang GTK</title>
      </Head>
      <AccountApp
        isRuangGtkV3Enabled={isRuangGtkV3Enabled}
        isRuangGtkEnabled={isRuangGtkEnabled}
      />
    </>
  )
}

AccountPage.layoutOpts = {
  hasHeader: false,
}

export default AccountPage
